// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"2abcd275","453":"50cbd403","796":"61c6571c"}[chunkId] + ".chunk.js";
};